import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ListItemElement, Thumbnail } from '@symplicity/syng';
import { EventsService, EventTypes } from '../../services';
import { ActionButtonClick } from './action-buttons/action-buttons.component';
import { EventViewHeader } from './event-view-header/event-view-header.component';
import { EventViewData } from './event-view.resolvers';

@Component({
    selector: 'cf-event-view',
    templateUrl: './event-view.component.html'
})
export class EventViewComponent {
    public readonly resolvedData = this.route.snapshot.data.resolvedData as EventViewData;
    public readonly event = this.resolvedData.event;
    public readonly actionButtons = this.resolvedData.actionButtons;
    public readonly tabData = this.resolvedData.tabData;
    public readonly headerData = this.getHeaderData();
    public readonly breadcrumbLink = this.event.status === 'passed' ? '/events/past' : '/events/upcoming';

    constructor(
        private route: ActivatedRoute,
        private translateService: TranslateService,
        private eventsService: EventsService,
        private title: Title
    ) {
        this.title.setTitle(this.event.label);
    }

    public onButtonClick(data: ActionButtonClick): void {
        if (data.button.id === 'registerAsEmployer') {
            this.eventsService.registerAsAnEmployer(this.event.event_id, this.event.disable_autofill);
        }
    }

    private getHeaderData(): EventViewHeader {
        const banner = this.getBanner();
        const eventDate = this.eventsService.getEventDateLabel('event', this.event);
        const tags = this.event.type._id === EventTypes.VirtualCareerFair
            ? [
                new ListItemElement({
                    label: this.translateService.instant('events tags.VIRTUAL'),
                    defaultStyleType: 'tag'
                })
            ]
            : [];

        return {
            banner,
            title: this.event.label,
            subtitle: eventDate.label,
            tags
        };
    }

    private getBanner(): Thumbnail | null {
        if (this.event.hero_banner && this.event.hero_banner.background_image) {
            const { background_image, background_image_alignment } = this.event.hero_banner;

            return new Thumbnail({
                src: background_image,
                imagePosition: background_image_alignment && background_image_alignment._id
                    ? background_image_alignment._id.replace('_', ' ')
                    : 'center center'
            });
        } else {
            return null;
        }
    }
}
